export enum EPAGE {
    INDEX,
    ERROR,
    PAGE_404,
    PAGE_50X,
}

export interface IBaseProps {
    page?: EPAGE;
}
